/* istanbul ignore file */
import React, { createContext, ReactNode, useContext, useMemo, useReducer, type Dispatch } from 'react';
import { STRINGS } from 'config';
import useReducerLogger from 'store/customLogger';
import { rootReducer, rootState } from 'store/reducer/rootReducer';
import { FeatureFlagProvider } from '@econsult/econsult-ui/dist/components/FlagControlledFeature/index';

const { IS_DEV_OR_TEST_ENV } = STRINGS.ENVIRONMENT;

export const SettingsStore = createContext({
  state: rootState,
  dispatch: (() => '') as Dispatch<any>, // eslint-disable-line @typescript-eslint/no-explicit-any
});

export const StoreProvider = ({ children, initialState = rootState }: any) => { // eslint-disable-line @typescript-eslint/no-explicit-any
  const loggedReducer = useReducerLogger(rootReducer);
  const [state, dispatch] = useReducer(IS_DEV_OR_TEST_ENV ? loggedReducer : rootReducer, initialState);
  if (IS_DEV_OR_TEST_ENV) {
    window.appDispatch = dispatch;
  }
  const store = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <SettingsStore.Provider value={store}>{children}</SettingsStore.Provider>
  );
};

export const useAppState = () => {
  const { state } = useContext(SettingsStore);

  return state;
};

export const useAppDispatch = () => {
  const { dispatch } = useContext(SettingsStore);

  return dispatch;
};

interface FeatureProviderProps {
  children: ReactNode;
}

export const FeatureProvider = ({ children }: FeatureProviderProps): JSX.Element => {
  const { featureFlags } = useAppState();
  return <FeatureFlagProvider featureFlags={featureFlags}>{children}</FeatureFlagProvider>;
};
